import cbAmericanExpress from 'url:../../../../../resource/images/cbAmericanExpress.png';
import cbDankort from 'url:../../../../../resource/images/cbDankort.png';
import cbDinersClub from 'url:../../../../../resource/images/cbDinersClub.png';
import cbDiscover from 'url:../../../../../resource/images/cbDiscover.png';
import cbJcb from 'url:../../../../../resource/images/cbJcb.png';
import cbMaestro from 'url:../../../../../resource/images/cbMaestro.png';
import cbMastercard from 'url:../../../../../resource/images/cbMastercard.png';
import cbUnionPay from 'url:../../../../../resource/images/cbUnionPay.png';
import cbVisa from 'url:../../../../../resource/images/cbVisa.png';
import logoSodexo from 'url:../../../../../resource/images/sodexo_pass_restaurant.jpg';
import logoNatixis from 'url:../../../../../resource/images/natixis_intertitres.jpg';
import logoEdenred from 'url:../../../../../resource/images/edenred_france.png';
import logoUpCheques from 'url:../../../../../resource/images/up_cheques_dej.png';
import logoLunchr from 'url:../../../../../resource/images/lunchr.png';
import logoDigibon from 'url:../../../../../resource/images/digibon_lunchboncard.png';
import logoMoneticoresto from 'url:../../../../../resource/images/cmcic_monetico_resto.jpg';
import logoMoneoresto from 'url:../../../../../resource/images/moneo_resto.jpg';
import logoSwile from 'url:../../../../../resource/images/swile.png';
import logoTicketRestaurant from 'url:../../../../../resource/images/ticket_restaurant.png';
import logoApetiz from 'url:../../../../../resource/images/apetiz.png';
import logoChequeDej from 'url:../../../../../resource/images/cheque_dejeuner.png';
import logoPassRestaurant from 'url:../../../../../resource/images/pass_restaurant.png';
import logoSofinco from 'url:../../../../../resource/images/logoSofinco.png';

const CB_LOGOS = [
    {
        name: 'American Express',
        type: 'AMEX',
        logo: cbAmericanExpress,
        regexes: [/^3[47]\d{4}\D{5}\d{4}$/],
        groupPattern: [/(.{1,4})(.{1,6})?(.{1,5})?/]
    },
    {
        name: 'Dankort',
        type: 'DANKORT',
        logo: cbDankort,
        regexes: [/^5019\d{2}\D{6}\d{4}$/]
    },
    {
        name: 'Visa',
        type: 'VISA',
        logo: cbVisa,
        regexes: [/^4\d{5}(\D{3}|\D{6}|\D{9})\d{4}$/],
        groupPattern: [/(.{1,4})(.{1,4})?(.{1,4})?(.{1,4})?(.{1,3})?/]
    },
    {
        name: 'Diners Club',
        type: 'DINERS',
        logo: cbDinersClub,
        regexes: [/^3(0[0-5]|[68]\d)\d{3}\D{4}\d{4}/],
        groupPattern: [/(.{1,4})?(.{1,6})?(.{1,4})?/]
    },
    {
        name: 'Discover',
        type: 'DISCOVER',
        logo: cbDiscover,
        regexes: [/^6(011(0\d|[2-4]\d|74|7[7-9]|8[6-9]|9\d)|4[4-9]\d{3}|5\d{4})\D{6}\d{4}$/]
    },
    {
        name: 'JCB',
        type: 'JCB',
        logo: cbJcb,
        regexes: [/^35\d{4}\D{6}\d{4}$/]
    },
    {
        name: 'Union Pay',
        type: 'UNION_PAY',
        logo: cbUnionPay,
        regexes: [/^62[0-5]\d{3}\D{6,9}\d{4}$/],
        groupPattern: [/(.{1,4})(.{1,4})?(.{1,4})?(.{1,4})?(.{1,3})?/]
    },
    {
        name: 'Maestro',
        type: 'MAESTRO',
        logo: cbMaestro,
        regexes: [/^(?:5[06789]\d\d|(?!6011[0234])(?!60117[4789])(?!60118[6789])(?!60119)(?!64[456789])(?!65)6\d{3})\d{2}\D{2,9}\d{4}$/],
        groupPattern: [/(.{1,4})(.{1,4})?(.{1,4})?(.{1,4})?(.{1,3})?/]

    },
    {
        name: 'Mastercard',
        type: 'MASTERCARD',
        logo: cbMastercard,
        regexes: [/^(5[1-5]\d{2}|222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)\d{2}\D{6}\d{4}$/]
    },
    {
        name: 'Sodexo Pass Restaurant',
        type: 'SODEXO',
        logo: logoSodexo,
        tradeName: 'Pass Restaurant',
        tradeLogo: logoPassRestaurant
    },
    {
        name: 'Natixis Intertitres',
        type: 'NATIXIS_INTERTITRE',
        logo: logoNatixis,
        tradeName: 'Apetiz',
        tradeLogo: logoApetiz
    },
    {
        name: 'Edenred France',
        type: 'EDENRED_FRANCE',
        logo: logoEdenred,
        tradeName: 'Ticket Resto',
        tradeLogo: logoTicketRestaurant
    },
    {
        name: 'UP Chèque Déjeuner',
        type: 'CHEQUE_DEJEUNER',
        logo: logoUpCheques,
        tradeName: 'Chèque Déjeuner',
        tradeLogo: logoChequeDej
    },
    {
        name: 'Lunchr',
        type: 'LUNCHR',
        logo: logoLunchr
    },
    {
        name: 'Swile',
        type: 'SWILE',
        logo: logoSwile
    },
    {
        name: 'Digibon LunchbonCard',
        type: 'DIGIBON',
        logo: logoDigibon
    },
    {
        name: 'CM CIC Monetico Resto',
        type: 'CM_CIC',
        logo: logoMoneticoresto
    },
    {
        name: 'Moneo Resto',
        type: 'MONEO_RESTO',
        logo: logoMoneoresto
    },
    {
        name: 'Sofinco',
        type: 'SOFINCO',
        logo: logoSofinco
    }
];

const findCbLogoFromType = (cardType) => CB_LOGOS.find(
    cbLogo => cbLogo.type === cardType
);

export { findCbLogoFromType };

export default CB_LOGOS;